import React from "react";
import ComponentContainer from "./ComponentContainer";
import MyLink from "./MyLink";
import { ReactComponent as QiwiSvg } from "../assets/svg/payments/qiwi.svg";
import { ReactComponent as SbpSvg } from "../assets/svg/payments/сбп.svg";
import { ReactComponent as MirSvg } from "../assets/svg/payments/мир.svg";
import { ReactComponent as MastercardSvg } from "../assets/svg/payments/mastercard.svg";
import { ReactComponent as VisaSvg } from "../assets/svg/payments/visa.svg";

import { LazyLoadImage } from "react-lazy-load-image-component";
import "../css/main-footer.css";
import { Link } from "react-router-dom";
import { independentPaths } from "../paths";

import A from "./A";
import logoFullImage from "../assets/img/logo-full.png";
import "../css/media-main-footer.css";
import MegalodonLinks from "../templates/MegalodonLinks";

const MainFooter = () => {
  return (
    <footer>
      <ComponentContainer>
        <div className="main-footer-container">
          <div className="footer-main-content">
            <div className="logo">
              <img
                src={logoFullImage}
                alt="Logo"
                style={{
                  maxWidth: "100%",
                }}
              />
            </div>
            <div className="links">
              <div className="links-container">
                <MyLink to="#">Играть</MyLink>
                <MyLink to="#">О нас</MyLink>
                <MyLink to="#">Мегашоп</MyLink>
              </div>
              <div className="links-container">
                <MyLink to="#">Мегапрофиль</MyLink>
                <MyLink to="#">Ивенты</MyLink>
                <MyLink to="#">Гильдии</MyLink>
              </div>
              <div className="links-container">
                <Link to={independentPaths.PrivacyPolicy}>
                  Политика конфиденциальности
                </Link>
                <Link to={independentPaths.PublicOffer}>Публичная оферта</Link>
                <MyLink to="#">Правила оплаты</MyLink>
              </div>
            </div>
            <div className="payment-and-other">
              <div className="payments">
                <QiwiSvg />
                <SbpSvg />
                <MirSvg />
                <MastercardSvg />
                <VisaSvg />
              </div>
              <div className="other-links">
                <div className="other-link"></div>
                <div className="other-link"></div>
                <div className="other-link"></div>
              </div>
            </div>
          </div>
          <div className="footer-privacy">
            <span className="copyright float-left">© 2024 MEGALODON</span>
            <span className="some-text">
              MEGALODON is not affiliated with or endorsed by The Isle or any
              other rights holder. All the used trademarks belong to their
              respective owners.
            </span>
            <div className="d-flex gap-1 justify-center flex-wrap">
              <span className="mr-2">
                <a href="mailto:megalodontheisle@gmail.com" className="contact">
                  megalodontheisle@gmail.com
                </a>
              </span>
              <MegalodonLinks size={"small"} />
            </div>
          </div>
        </div>
      </ComponentContainer>
    </footer>
  );
};

export default MainFooter;
